import axios from "axios";
import { getApiErrorMessage } from "../../utils/apiError";
import { getAuthHeader } from "../../utils/authHeader";
import { AccountHealthOverview } from "./types";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/admin/account-health`;

// One night's list. `day` ("YYYY-MM-DD") picks a past night; without it the
// latest night with a snapshot.
export async function getAccountHealth(day?: string): Promise<AccountHealthOverview> {
    try {
        const headers = await getAuthHeader();
        const params: Record<string, string> = {};
        if (day) params.day = day;
        const response = await axios.get<AccountHealthOverview>(BASE_URL, { params, headers });
        return response.data;
    } catch (error) {
        console.error("Error fetching account health:", error);
        // Keep the server's own words (a bad ?day= says why); otherwise plain.
        throw new Error(getApiErrorMessage(error, "The server did not answer."));
    }
}
